import { useEffect, useState } from "react";
import { Trash2, Heart } from "lucide-react";
import { toast } from "sonner";
import { KidAvatar } from "../Brand";
import { parentApi, streamUrl, thumbUrl, PARENT_KEY } from "../../lib/api";
import { catById, timeAgo } from "../../lib/constants";

const PILL = { pending: "#FFD23F", approved: "#B8F2C9", rejected: "#FF8FC7" };

export const VideoLibrary = ({ onChange }) => {
  const [videos, setVideos] = useState(null);
  const load = () => parentApi.get("/parent/videos").then((r) => setVideos(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (v) => {
    if (!window.confirm(`Remove "${v.title}"? It will disappear for everyone.`)) return;
    await parentApi.delete(`/parent/videos/${v.id}`);
    toast.success("Video removed");
    load();
    onChange();
  };

  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-bold">All videos</h1>
      {videos?.length === 0 && <p data-testid="library-empty" className="zn-card p-8 bg-white">No videos yet.</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {videos?.map((v) => (
          <div key={v.id} data-testid={`library-video-${v.id}`} className="zn-card bg-white overflow-hidden">
            <video src={streamUrl(v.id, localStorage.getItem(PARENT_KEY))} poster={v.thumb ? thumbUrl(v.id, localStorage.getItem(PARENT_KEY)) : undefined} controls playsInline preload="none" className="w-full aspect-video object-cover bg-[#1B1A2E] border-b-[3px] border-[#1B1A2E]" />
            <div className="p-4 space-y-2">
              <div className="flex items-center gap-2">
                <KidAvatar avatar={v.author?.avatar} color={v.author?.color} size={28} className="!border-2" />
                <span className="text-sm font-semibold">{v.author?.name}</span>
                <span data-testid={`library-status-${v.id}`} className="ml-auto text-xs px-2 py-1 rounded-full border-2 border-[#1B1A2E] capitalize" style={{ background: PILL[v.status] }}>{v.status}</span>
              </div>
              <h3 className="font-display text-xl font-semibold truncate">{v.title}</h3>
              <div className="flex items-center text-sm text-[#1B1A2E]/60 gap-2">
                {catById(v.category).label} · {timeAgo(v.created_at)} · <Heart size={12} /> {v.cheers?.length || 0}
                <button data-testid={`library-remove-${v.id}`} onClick={() => remove(v)} className="ml-auto p-2 rounded-full hover:bg-[#FF8FC7] transition-colors" title="Remove"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
